import React, { FC, useRef } from "react";
import styles from "./index.module.scss";
import { IMaskInput } from "react-imask";
import clsx from "clsx";

interface IInput {
  value: string;
  onChange: (val: string) => void;
  mask: string;
  placeholder?: string;
  resetValue?: () => void;
  wrapperClass?: string;
  inputClass?: string;
  disabled?: boolean
}

export const Input: FC<IInput> = ({
  value,
  onChange,
  mask,
  placeholder = "Введите номер карты",
  resetValue,
  wrapperClass = "",
  inputClass = "",
  disabled = false,
}) => {
  const ref = useRef(null);
  const inputRef = useRef(null);
  return (
    <div className={clsx(styles.wrapper, wrapperClass)}>
      <IMaskInput
        className={clsx(styles.input, inputClass)}
        mask={mask}
        value={value}
        unmask={true}
        ref={ref}
        inputRef={inputRef}
        onAccept={(value, mask) => onChange(value)}
        placeholder={placeholder}
        disabled={disabled}
      />
      {resetValue && value && <CloseIcon onClick={resetValue} />}
    </div>
  );
};

export const CloseIcon = ({ onClick }: { onClick: () => void }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      onClick={onClick}
    >
      <path
        d="M19.8839 5.88388C20.372 5.39573 20.372 4.60427 19.8839 4.11612C19.3957 3.62796 18.6043 3.62796 18.1161 4.11612L12 10.2322L5.88388 4.11612C5.39573 3.62796 4.60427 3.62796 4.11612 4.11612C3.62796 4.60427 3.62796 5.39573 4.11612 5.88388L10.2322 12L4.11612 18.1161C3.62796 18.6043 3.62796 19.3957 4.11612 19.8839C4.60427 20.372 5.39573 20.372 5.88388 19.8839L12 13.7678L18.1161 19.8839C18.6043 20.372 19.3957 20.372 19.8839 19.8839C20.372 19.3957 20.372 18.6043 19.8839 18.1161L13.7678 12L19.8839 5.88388Z"
        fill="white"
      />
    </svg>
  );
};
